export const rtlLangs: string[] = ['ar-SA', 'ar-EG'];
